var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-container"},[_c('ListHeader',{attrs:{"title":"三级维度指标"}},[_c('template',{slot:"right"},[_c('ActionButton')],1)],2),_c('div',{staticClass:"content"},[_c('Score')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }